import { AnchorLink } from './Reveal';

const EXPLORE = [
  { label: 'About Us', href: '#about', testid: 'footer-about-link' },
  { label: 'Core Services', href: '#services', testid: 'footer-services-link' },
  { label: 'Our Ecosystem', href: '#ecosystem', testid: 'footer-ecosystem-link' },
  { label: 'Upcoming Apps', href: '#digital-platforms', testid: 'footer-platforms-link' },
  { label: 'Careers', href: '#for-job-seekers', testid: 'footer-careers-link' },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="grain-dark relative overflow-hidden bg-royal-ink text-white">
      <div aria-hidden="true" className="absolute -left-24 top-0 h-72 w-72 rounded-full bg-royal/50 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="inline-flex items-center rounded-2xl bg-white px-5 py-3 shadow-lift">
              <img src="/assets/sania-logo.png" alt="Sania Job Bowl — official logo" className="h-10 w-auto" />
            </div>
            <p className="mt-6 font-display text-lg font-extrabold">Sania Job Bowl Pvt. Ltd.</p>
            <p className="mt-1 font-display text-base font-bold italic text-lime">A smile in Every Job.</p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/60">
              Connecting talent, empowering businesses and creating opportunities through integrated workforce and
              career solutions.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.26em] text-white/40">Explore</p>
            <ul className="mt-5 space-y-3">
              {EXPLORE.map((l) => (
                <li key={l.href}>
                  <AnchorLink
                    href={l.href}
                    testid={l.testid}
                    className="link-slide text-sm font-semibold text-white/75 transition-colors duration-200 hover:text-lime"
                  >
                    {l.label}
                  </AnchorLink>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.26em] text-white/40">Get in touch</p>
            <ul className="mt-5 space-y-3 text-sm font-semibold text-white/75">
              <li>
                <a href="tel:+916361186321" data-testid="footer-phone-link" className="link-slide transition-colors duration-200 hover:text-lime">
                  +91 63611 86321
                </a>
              </li>
              <li>
                <a href="mailto:connect@saniajobbowl.com" data-testid="footer-email-link" className="link-slide break-all transition-colors duration-200 hover:text-lime">
                  connect@saniajobbowl.com
                </a>
              </li>
              <li>
                <AnchorLink href="#contact" testid="footer-contact-link" className="link-slide transition-colors duration-200 hover:text-lime">
                  Employer Enquiries
                </AnchorLink>
              </li>
            </ul>
            <a
              href="https://wa.me/916361186321?text=Hello%20Sania%20Job%20Bowl%2C%20I%20would%20like%20to%20discuss%20a%20workforce%20requirement."
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              className="mt-7 inline-flex items-center gap-2.5 rounded-full bg-[#1FAF57] px-6 py-3.5 font-display text-[13px] font-bold uppercase tracking-[0.12em] text-white transition-[transform,box-shadow,background-color] duration-200 hover:-translate-y-0.5 hover:bg-[#189c4c] hover:shadow-[0_16px_32px_-12px_rgba(31,175,87,0.7)]"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4" aria-hidden="true">
                <path d="M12.04 2a9.9 9.9 0 0 0-8.4 15.2L2 22l4.95-1.6A9.9 9.9 0 1 0 12.04 2Zm5.77 14.06c-.24.68-1.4 1.3-1.94 1.35-.5.05-1.13.24-3.8-1.05-3.2-1.56-5.2-5.02-5.36-5.25-.16-.24-1.27-1.76-1.2-3.3.07-1.54.9-2.27 1.2-2.58.3-.3.66-.36.88-.36h.63c.2 0 .48-.08.73.6l.98 2.4c.08.17.14.36.02.57l-.36.55c-.12.15-.25.32-.36.43-.12.12-.25.25-.11.5.14.24.62 1.06 1.34 1.72.92.85 1.7 1.12 1.94 1.24.24.12.39.1.53-.06.14-.16.62-.72.78-.97.16-.24.33-.2.55-.12.22.08 1.42.67 1.66.8.24.12.4.18.46.28.06.1.06.6-.18 1.25Z" />
              </svg>
              WhatsApp Us ↗
            </a>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-7">
          <p className="text-xs leading-relaxed text-white/45" data-testid="footer-copyright">
            © 2026 Sania Job Bowl Pvt. Ltd. All rights reserved. · Website content subject to service availability
            and agreed commercial terms.
          </p>
        </div>
      </div>
    </footer>
  );
}
